export default "__VITE_ASSET__B$yukguO__"